import React from 'react';
import PropTypes from 'prop-types';
import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';

const { Dragger } = Upload;

const FileUpload = ({ onFileSelect, selectedFile }) => {
  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: '.pdf,application/pdf',
    defaultFileList: selectedFile ? [selectedFile] : [],
    beforeUpload: (file) => {
      // Prevent the default upload behavior
      if (onFileSelect) {
        onFileSelect(file);
      }
      return false; // Prevent upload
    },
    onChange(info) {
      // Just log the file info without actually uploading
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('File selected:', info.file, info.fileList);
      }
    },
    onDrop(e) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('Dropped files', e.dataTransfer.files);
      }

      // If there are files and onFileSelect is provided, pass the first file
      if (e.dataTransfer.files.length > 0 && onFileSelect) {
        onFileSelect(e.dataTransfer.files[0]);
      }
    },
  };

  return (
    <Dragger {...uploadProps}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag PDF file to this area to upload</p>
    </Dragger>
  );
};

FileUpload.propTypes = {
  onFileSelect: PropTypes.func,
  selectedFile: PropTypes.object,
};

export default FileUpload;
